import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core";
import { Error } from "@material-ui/icons";
import moment from "moment";
import Selector2 from "../Selector2";
import Loader from "../Loader";
import { updateAccount } from "../../actions/index";
import { tz } from "../../utils/tz";

function Profile(props) {
  const { classes, t, account, changeTab } = props;
  const { profile, level } = account.account;

  const [timezone, changeTimezone] = useState(account.account.time_zone);
  const [currency, changeCurrency] = useState(account.account.base_currency);
  const [statements, changeStatements] = useState(
    account.account.account_statements_enabled
  );

  useEffect(
    function () {
      if (account.account.base_currency !== currency.toLowerCase()) {
        props.updateAccount({ base_currency: currency.toLowerCase() });
      }
      if (account.account.account_statements_enabled !== statements) {
        props.updateAccount({ account_statements_enabled: statements });
      }

      if (account.account.time_zone !== timezone) {
        props.updateAccount({ time_zone: timezone });
      }
    },
    [currency, statements, timezone]
  );

  const fiatCurrencies = ["USD", "EUR", "CAD", "GBP", "JPY", "AED"];

  if (profile === null) {
    return (
      <div className={classes.profileContainer}>
        {/* <div className="upgrade">
          <Error />
          <p>{t("upgradeMessage")}</p>
          <button className="upgradeBtn" onClick={() => changeTab("accType")}>
            {t("upgradeAcc").toUpperCase()}
          </button>
        </div> */}

        <h2>{account.account.email}</h2>
        <div className="infoItem">
          <p>{t("_accountId")}</p>
          <span>{account.account.uid}</span>
        </div>
        <div className="infoItem">
          <p>{t("email")}</p>
          <span>{account.account.email}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.profileContainer}>
      <h2>
        {profile.first_name} {profile.middle_name ? profile.middle_name : ""}{" "}
        {profile.last_name}
      </h2>
      <div className="infoItem">
        <p>{t("_accountId")}</p>
        <span>{account.account.uid}</span>
      </div>
      <div className="infoItem">
        <p>{t("email")}</p>
        <span>{account.account.email}</span>
      </div>
      <div className="infoItem">
        <p>{t("dateOfBirth")}</p>
        <span>
          {profile.birthdate
            ? moment(profile.birthdate).format("MMMM DD, YYYY")
            : "--"}
        </span>
      </div>
      <div className="infoItem">
        <p>{t("address")}</p>
        <span>
          {profile.address
            ? `${profile.address}, ${profile.city}, ${profile.country}`
            : "--"}
        </span>
      </div>
      <div className="infoItem">
        <p>{t("occupation")}</p>
        <span>{profile.occupation ? profile.occupation : "--"}</span>
      </div>
      {/* <div className="infoItem">
        <p>{t("jobTitle")}</p>
        <span>{profile.job_title ? profile.job_title : "--"}</span>
      </div> */}
      <div className="infoItem selectorItem">
        <p>{t("timezone")}</p>

        <Selector2
          options={tz}
          selectorHandle={changeTimezone}
          selectedOption={timezone}
          width="50%"
        />
      </div>
      <div className="infoItem selectorItem">
        <p>{t("defaultCurrency")}</p>

        <Selector2
          options={fiatCurrencies}
          selectorHandle={changeCurrency}
          selectedOption={currency.toUpperCase()}
          width="50%"
        />
      </div>

      {/* <div className="infoItem selectorItem">
        <p>{t("accountStatements")}</p>

        <Selector2
          type="boolean"
          options={[t("receiveMonthly"), t("disabled")]}
          selectorHandle={changeStatements}
          selectedOption={statements ? t("receiveMonthly") : t("disabled")}
          width="50%"
        />
      </div> */}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateAccount,
    },
    dispatch
  );
}

const styles = (theme) => ({
  profileContainer: {
    width: "100%",
    maxWidth: 1100,
    background: theme.colors.background.fore,
    padding: "24px 40px",
    borderRadius: 4,
    boxShadow: theme.defaults.shadow,
    "& .upgrade": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: 400,
      "& svg": {
        color: theme.colors.buttons.sell,
        fontSize: 32,
      },
      "& button": theme.defaults.roundBtn,
      "& p": {
        width: 280,
        margin: "16px auto",
        fontSize: 18,
        // fontFamily: "Titillium Web",
        fontWeight: 600,
        lineHeight: "27px",
        textAlign: "center",
      },
      "& .upgradeBtn": {
        background: "none",
        border: `1px solid ${theme.colors.buttons.green}`,
        color: theme.colors.buttons.green,
        fontSize: 14,
        width: 230,
        color: theme.colors.text.primary,
      },
    },
    "& h2": {
      fontSize: 28,
      // fontFamily: "Titillium Web",
      fontWeight: 600,
      width: "100%",
      borderBottom: `1px solid ${theme.colors.misc.dividers}`,
      paddingBottom: 16,
    },
    "& .infoItem": {
      display: "flex",
      alignItems: "center",
      margin: "32px 0",
      [theme.breakpoints.down(600)]: {
        justifyContent: "space-between",
      },
      "& p": {
        width: "25%",
        fontWeight: 600,
      },
      "& span": {
        color: theme.colors.text.secondary,
        [theme.breakpoints.down(600)]: {
          textAlign: "right",
        },
      },
      "&.selectorItem": {
        margin: "16px 0",
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Profile))
);
